
export const LOGIN_CODE = 'login_code'
export const USER_LOGIN = 'user_login'
export const USER_INFO = 'user_info'
export const USER_INFO_EDIT = 'user_info_edit'
export const USER_INFO_INQUIRE = 'user_info_inquire'
export const USER_LOGIN_SCORE = 'user_login_score'
export const USER_LIST_GATHER = 'user_list_gather'
export const USER_THIRD_LOGIN = 'USER_THIRD_LOGIN'

//首页左上数据TeaMessage
export const TEAMESSAGE = 'tea_message_list'

//首页中间数据TeaMessage
export const CENTREMESSAGE = 'centre_message_list'

//首页左上数据TeaMessage
export const COURSEMESSAGE = 'course_message_list'

//首页中间数据TeaMessage
export const BASEMESSAGE = 'base_message_list'

//首页课程评价list
export const BASE_EVALUATION_LIST = 'BASE_EVALUATION_LIST'

//首页课程评价del
export const BASE_EVALUATION_DEL = 'base_evaluation_del'


export const JXTALK_LIST = 'jxtalk_list'
// 密码安全强度
export const USER_PASSWORDVERIFY = 'user_passwordverify'
// 密码是否失效
export const USER_PASSWORDSECURITY = 'user_passwordsecurity'


// WEBPACK FOOTER //
// ./src/store/user/type.js